import type { Role } from "@/store/auth-store";

/**
 * Where a freshly-authenticated user belongs.
 *
 * A candidate holds one permission and has exactly one page; everyone
 * else is staff and starts in the console. Sending a candidate to /admin
 * would render the chrome and then 403 on every request behind it -- a
 * broken-looking app for a first-time user whose entire impression of
 * the practice is this screen.
 *
 * Kept as a pure function in its own module so the two call sites -- the
 * post-login redirect and the catch-all route -- cannot drift apart.
 */
export function landingPathFor(role: Role | null | undefined): string {
  if (role === "TESTRAD") return "/tests";
  return "/admin";
}
